export const locale = {
  lang: "de",
  data: {
    MENU: {
      HOME: "Startseite",
      USERS: "Benutzer",
      CLIENTS: "Klient:innen",
      HOUSING: "Wohnungen",
      EMPLOYEES: "Betreuer:innen",
      OFFICES: "Standorte",
      REPORTS: "Berichte",
    },
    AUTH: {
      WELCOME: "Willkommen beim Kinderfreunde Dokutool! 🗒️",
      INTRO: "Bitte loggen Sie sich ein, um Zugriff auf die Funktionalitäten zu erhalten",
      FIRST_NAME: "Vorname",
      NAME: "Nachname",
      EMAIL: "E-Mail",
      PASSWORD: {
        PASSWORD: "Passwort",
        FORGOT: "Passwort vergessen?",
        FORGOT_HEADER: "Passwort vergessen? 🔑",
        RESET: "Gerne schicken wir Ihnen eine E-Mail über die Sie Ihr Passwort zurücksetzen können.",
        RESET_LINK: "Link senden",
        RESET_HEADER: "Passwort zurücksetzen 🔒",
        NEW: "Neues Passwort",
        CONFIRM: "Neues Passwort bestätigen",
        FORGOT_SUCCESS_TITLE: "E-Mail versendet",
        FORGOT_SUCCESS_MESSAGE: "Über die E-Mail können Sie Ihr Passwort zurücksetzen.",
        RESET_SUCCESS_TITLE: "Passwort zurückgesetzt 🔐",
        RESET_SUCCESS_MESSAGE: "Sie können sich jetzt mit dem neuen Passwort einloggen.",
      },
      ERRORS: {
        FIRST_NAME_REQUIRED: "Nachname ist ein Pflichtfeld!",
        NAME_REQUIRED: "Nachname ist ein Pflichtfeld!",
        EMAIL_REQUIRED: "E-Mail-Adresse ist ein Pflichtfeld!",
        EMAIL: "Bitte geben Sie eine gültige E-Mail-Adresse an!",
        PASSWORD: "Passwort ist ein Pflichtfeld!",
        PASSWORD_MIN_LENGTH: "Das Passwort muss mindestens 5 Zeichen haben!",
        PASSWORD_CHECK: "Passwörter stimmen nicht überein!",
      },
      REMEMBER_ME: "Angemeldet bleiben",
      SIGN_IN: "Anmelden",
      NEW: "Neu hier? ",
      REGISTER: "Benutzer erstellen",
      OR: "oder",
      REGISTER_SUCCESS_TITLE: "Willkommen, {{name}}! 👋",
      BACK_TO_LOGIN: "Zurück zum Login",
      REGISTER_TITLE: "Das Abenteuer beginnt 🚀",
      USERNAME: "Username",
      TCS: "Ich stimme der Datenschutzrichtlinie und den AGB zu",
      ALREADY_REGISTERED: "Bereits registriert?",
    },
    NAV: {
      PROFILE: "Profil",
      INBOX: "Posteingang",
      TASK: "Aufgabe",
      CHATS: "Chats",
      LOGOUT: "Abmelden",
      USER: "Benutzer",
      RESTAURANT: "Unternehmen",
      REPRESENT: "Vertretung",
    },
  },
};
